import { getCurrentEnv } from '../hooks/apiUrlResolver';

const MINUTE = 60 * 1000;


const authConstants = {
  DEV_PORTAL_PORT: 3000,
  FR_UI_PORT: 3001,
  AUTH_CLIENT_ID: 'WebOAuthClient',
  REALM_PATH: 'alpha',
  JOURNEY_LOGIN: 'avLogin',
  SESSION_COOKIE_NAME: 'sessionAka',
  SESSION_TIMER: 30 * MINUTE,
  WARNING_TIMER: 25 * MINUTE,
  AXI_EXPIRATION_TIMER: 20 * MINUTE,
  ACTIVITY_SYNC_TIMER: 0.5 * MINUTE,
  RESET_TIMER_THROTTLE: 1000,
  ACTIVITY_SYNC_KEY: 'timerPing',
  AUTH_STATE_KEY: 'auth-state',
  getCookieName: (): string => {
    const currentEnv = getCurrentEnv();
    if (currentEnv === 'prd') return '3e2c59477f32ed6';
    if (currentEnv === 'qap') return '41628150c56c071';
    if (currentEnv === 'qua') return '8cd219f60ec3052';
    return 'b3c95ac1e326997';
  },
  getWarningDuration: (): number => authConstants.SESSION_TIMER - authConstants.WARNING_TIMER,
  getNewWarningTimer: (startTime = Date.now()): number => startTime + authConstants.WARNING_TIMER,
  getNewSessionTimer: (startTime = Date.now()): number => startTime + authConstants.SESSION_TIMER,
  getNextResetTimer: (): number => Date.now() + authConstants.RESET_TIMER_THROTTLE
};

export default authConstants;
